import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, FormGroup, Form, Input, Row, Col } from "reactstrap";
import Select from 'react-select'
import MaterialTable from 'material-table';
import ReactTagInput from "@pathofdev/react-tag-input";
import Switch from 'react-switch';

// style
import { table_translate, table_style } from "../../../../constants/MaterialTable.js";
import "@pathofdev/react-tag-input/build/index.css";

// helpers
import { showMessage, showQuestion } from "../../../../helpers/message.js";

// api
import formulariovistoria_api from "../../../../api/formulariovistoria_api.js";

export default function FormularioFichaCabecalho({ setshowLoading, isDisable, formularioVistoria, update }) {

    const { register, errors, handleSubmit, setValue, clearErrors } = useForm({ mode: "onBlur" });

    // Tipo de Valor
    const options_tipoValor = [
        { label: "Data", value: "Data" },
        { label: "Lista", value: "Lista" },
        { label: "Número", value: "Número" },
        { label: "Texto", value: "Texto" }
    ];
    const [tipoValor, set_tipoValor] = useState(null);
    const handleChangeTipoValor = (value) => {
        set_tipoValor(value);
        clearErrors("tipoValor");
        setValue("tipoValor", value, true);
    }

    // Opções de Resposta
    const [opcoesResposta, set_opcoesResposta] = useState([]);

    // Campo Obrigatório
    const [obrigatorio, set_obrigatorio] = useState(false);
    const handleChangeObrigatorio = value => {
        set_obrigatorio(value);
    }

    // Lista de cabeçalhos
    const [list_table, set_list_table] = useState([]);

    // Edição do Cabeçalho
    const [rowEdit, set_rowEdit] = useState(null);
    const handleEdit = (rowData) => {
        set_rowEdit(rowData);
        setValue("sequencia", rowData.sequencia);
        setValue("identificacao", rowData.identificacao);
        set_tipoValor(rowData.tipoValor);
        setValue("tipoValor", rowData.tipoValor, true);
        set_obrigatorio(rowData.obrigatorio);

        let _opcoesResposta = [];
        if (rowData.tipoValor == "Lista")
            rowData.formularioVistoriaCabecalhoOpcos.map(m => _opcoesResposta.push(m.valor));
        set_opcoesResposta(_opcoesResposta);
    }

    // Delete
    const handleDelete = (rowData) => {
        showQuestion("Atenção", "Tem certeza que quer excluir o item?", "question", function (success) {
            if (success) {
                setshowLoading(true);
                formulariovistoria_api.deleteFormularioVistoriaCabecalho(rowData.formularioVistoriaCabecalho_Id).then(result => {
                    setshowLoading(false);
                    if (result.status !== 200)
                        showMessage("Aviso", result.message, 'error', null);
                    else {
                        showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                            let _list = list_table.filter(f => f.formularioVistoriaCabecalho_Id != rowData.formularioVistoriaCabecalho_Id);
                            set_list_table(_list);

                            let _formulario = formularioVistoria;
                            _formulario.formularioVistoriaCabecalhos = _list;
                            update(_formulario);
                        });
                    }
                });
            }
        });
    }

    const loadForm = () => {
        set_list_table(formularioVistoria.formularioVistoriaCabecalhos);
    }

    useEffect(() => {
        loadForm();
    }, []);

    const onSubmit = (data) => {
        if (list_table.filter(f => f.sequencia == data.sequencia && rowEdit && rowEdit.formularioVistoriaCabecalho_Id != f.formularioVistoriaCabecalho_Id).length > 0) {
            showMessage("Aviso", "Já existe um cabeçalho com este número de sequência.", 'error', null);
            return;
        }

        if (tipoValor == "Lista" && opcoesResposta.length == 0) {
            showMessage("Aviso", "Informe as opções de resposta da lista.", 'error', null);
            return;
        }

        let formularioVistoriaCabecalhoOpcos = [];
        if (tipoValor == "Lista") {
            opcoesResposta.map(m => {
                formularioVistoriaCabecalhoOpcos.push({
                    formularioVistoriaCabecalhoOpcao_Id: rowEdit ? rowEdit.formularioVistoriaCabecalhoOpcos.filter(f => f.valor == m)[0]?.formularioVistoriaCabecalhoOpcao_Id : 0,
                    formularioVistoriaCabecalho_Id: rowEdit ? rowEdit.formularioVistoriaCabecalho_Id : 0,
                    valor: m
                });
            })
        }

        let json_submit = {
            formularioVistoriaCabecalho_Id: rowEdit ? rowEdit.formularioVistoriaCabecalho_Id : 0,
            formularioVistoria_Id: formularioVistoria.formularioVistoria_Id,
            sequencia: data.sequencia,
            identificacao: data.identificacao,
            tipoValor: tipoValor,
            obrigatorio: obrigatorio,
            formularioVistoriaCabecalhoOpcos: formularioVistoriaCabecalhoOpcos
        }

        setshowLoading(true);
        if (json_submit.formularioVistoriaCabecalho_Id == 0)
            formulariovistoria_api.postFormularioVistoriaCabecalho(json_submit).then(result => handleReturnSubmit(result));
        else
            formulariovistoria_api.putFormularioVistoriaCabecalho(json_submit).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                // Atualiza a lista local
                let _list = list_table.filter(f => f.formularioVistoriaCabecalho_Id != result.data.formularioVistoriaCabecalho_Id);
                _list.push(result.data);
                set_list_table(_list);

                // Atualiza a state principal
                let _formulario = formularioVistoria;
                _formulario.formularioVistoriaCabecalhos = _list;
                update(_formulario);

                // Limpa campos da tela
                setValue("sequencia", "");
                setValue("identificacao", "");
                set_tipoValor("");
                setValue("tipoValor", "", false);
                set_obrigatorio(false);
                set_opcoesResposta([]);
                set_rowEdit(null);
            });
        }
    }

    return (
        <>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className="align-items-end">
                    <Col lg="2" md="4" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Sequência</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="number"
                                name="sequencia"
                                innerRef={register({ required: true })}
                                disabled={isDisable}
                            />
                            {errors.sequencia && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="10" md="8" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Identificação</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="identificacao"
                                innerRef={register({ required: true })}
                                disabled={isDisable}
                            />
                            {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Tipo de valor</label>
                            <Select
                                name="tipoValor"
                                options={options_tipoValor}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                value={options_tipoValor.filter(f => f.value == tipoValor)}
                                onChange={(o) => handleChangeTipoValor(o.value)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                ref={e => register(
                                    { name: "tipoValor" },
                                    { required: true })
                                }
                                isDisabled={isDisable}
                            />
                            {errors.tipoValor && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="6" sm="12">
                        <FormGroup>
                            <label htmlFor="obrigatorio">
                                <span>Campo obrigatório</span><br />
                                <Switch name="obrigatorio"
                                    id="obrigatorio"
                                    className="react-switch"
                                    checked={obrigatorio}
                                    onChange={handleChangeObrigatorio}
                                    onColor="#86d3ff"
                                    onHandleColor="#2693e6"
                                    disabled={isDisable}
                                />
                            </label>
                        </FormGroup>
                    </Col>
                    <Col lg="12" md="12" sm="12" className={tipoValor == "Lista" ? "" : "d-none"}>
                        <FormGroup>
                            <label className="form-control-label">Opções de resposta</label>
                            <ReactTagInput
                                tags={opcoesResposta}
                                onChange={(newTags) => set_opcoesResposta(newTags)}
                                autocomplete="off"
                                type="text"
                                name="opcoesResposta"
                                placeholder="Digite e pressione ENTER"
                                removeOnBackspace={false}
                                readOnly={isDisable}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                {!isDisable &&
                    <Row>
                        <Col lg="12" md="12" sm="12" className="text-center">
                            <Button color="success" type="submit"><i className="fas fa-plus"></i> Adicionar</Button>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col lg="12">
                        <MaterialTable style={{ minHeight: "auto" }}
                            title="Lista de Campos do Cabeçalho"
                            columns={[
                                { title: 'Sequência', field: 'sequencia' },
                                { title: 'Identificação', field: 'identificacao' },
                                { title: 'Tipo de valor', field: 'tipoValor' },
                                { title: 'Campo obrigatório', render: (rowData) => rowData.obrigatorio ? "Sim" : "Não" }
                            ]}
                            data={list_table}
                            isLoading={false}
                            options={{
                                ...table_style,
                                filtering: false,
                                exportButton: true
                            }}
                            actions={[
                                {
                                    icon: 'edit',
                                    tooltip: 'Editar Registro',
                                    onClick: (event, rowData) => handleEdit(rowData)
                                },
                                {
                                    icon: 'delete',
                                    tooltip: 'Remover',
                                    onClick: (event, rowData) => handleDelete(rowData)
                                }
                            ]}
                            localization={table_translate}
                        />
                    </Col>
                </Row>
            </Form>
        </>
    );
}

